import {
	fabric
} from 'fabric';
import $ from "jquery";
let fabcanvas;
let canvas_zoom_perc = '100';
const CUSTOM_PROPS = ['pimage', 'pname', 'skutxt', 'productcolorcode', 'productwprice', 'productrprice', 'padding'];
let mainBuyplanItems = null;
let canvasBuyplanItems = null;
let selectorBuyplanItems = null;
let SEL_MONTH = null;
let IS_EXPORT_PDF = false;
let FITCANVASVALUE = null;

export function getSelMonth() {
	return SEL_MONTH;
}

export function setSelMonth(month) {
	SEL_MONTH = month;
}

export function getIsExportPDF() {
	return IS_EXPORT_PDF;
}

export function setIsExportPDF(flag) {
	IS_EXPORT_PDF = flag;
}

export function getMainBuyplanItems() {
	return mainBuyplanItems;
}

export function setMainBuyplanItems(buyplanitems) {
	mainBuyplanItems = buyplanitems;
}

export function getCanvasBuyplanItems() {
	return canvasBuyplanItems;
}

export function setCanvasBuyplanItems(buyplanitems) {
	canvasBuyplanItems = buyplanitems;
}

export function getSelectorBuyplanItems() {
	return selectorBuyplanItems;
}

export function setSelectorBuyplanItems(buyplanitems) {
	selectorBuyplanItems = buyplanitems;
}

export function getCustomProps() {
	return CUSTOM_PROPS;
}

export function getCanvas() {
	return fabcanvas;
}

export function setCanvas(canvas) {
	if (canvas) fabcanvas = canvas;
}

export function addImage(pimage, options, pname, skutxt, productcolorcode, productwprice, productrprice) {
	addGroupedImage(pimage, options, pname, skutxt, productcolorcode, productwprice, productrprice);
	saveCanvasState();
	$("#" + skutxt).hide();
}

export function addGroupedImage(pimage, options, pname, skutxt, productcolorcode, productwprice, productrprice, opacity = 1) {
	const canvas = getCanvas();
	const zoom = canvas.getZoom();
	fabric.Image.fromURL(pimage, function (img) {
		img.scaleToHeight(80);

		let product_text = '';
		if ($("#product_name").prop('checked')) {
			product_text = pname;
		}
		if ($("#product_sku").prop('checked')) {
			if (product_text.length > 0) product_text += "\n";
			product_text += "SKU: " + skutxt;
		}
		if ($("#product_color").prop('checked')) {
			if (product_text.length > 0) product_text += "\n";
			product_text += productcolorcode;
		}
		if ($("#product_wprice").prop('checked')) {
			if (product_text.length > 0) product_text += "\n";
			product_text += productwprice;
		}
		if ($("#product_rprice").prop('checked')) {
			if (product_text.length > 0) product_text += "\n";
			product_text += productrprice;
		}
		const producttext = new fabric.Textbox(product_text.toUpperCase(), {
			top: 90,
			width: img.width * img.scaleX,
			fontSize: 7,
			fontFamily: 'Roboto',
			textAlign: "center",
			fill: 'black',
			fontWeight: 500
		});

		// add image and text to a group
		const group = new fabric.Group([img, producttext], {
			originX: 'center',
			originY: 'center'
		});

		if (options) {
			group.left = options.left;
			group.top = options.top;
			group.setCoords();
			if (options.scaleX) {
				group.scaleX = options.scaleX;
				group.scaleY = options.scaleY;
			}
		} else {
			group.left = canvas.width / 2;
			group.top = canvas.height / 2;
			group.setCoords();
		}

		group.setControlsVisibility({
			mt: false,
			mb: false,
			ml: false,
			mr: false
		});

		group.pimage = pimage;
		group.pname = pname;
		group.skutxt = skutxt;
		group.productcolorcode = productcolorcode;
		group.productwprice = productwprice;
		group.productrprice = productrprice;

		group.opacity = opacity;

		// add the group to canvas
		canvas.add(group);
		group.scaleToWidth(100 * zoom);
		if (group.opacity)
			canvas.setActiveObject(group);
		canvas.renderAll();
	}, {
		crossOrigin: 'anonymous'
	});
}

export function updateSelectionCanvasItems() {

	if (!fabcanvas) return false;

	fabcanvas.discardActiveObject().renderAll();

	//check and remove the product not matching the buyplan items
	const buyplanItems = getCanvasBuyplanItems();
	const productids = [];
	if (buyplanItems)
		for (let buyplanItem of buyplanItems.values()) {
			const shortMonth = buyplanItem.get("short_month");
			if (shortMonth === getSelMonth()) {
				buyplanItem.get("items").map((item) => {
					productids.push(String(item.get("id")));
				})
			}
		}

	$('.product').show();

	const objects = fabcanvas.getObjects().filter(function (o) {
		return o.skutxt !== '';
	});

	for (let i = 0; i < objects.length; i++) {
		const object = objects[i];
		if (object.skutxt) {
			if (checkIFProductExists(productids, object.skutxt) && $("#applyto_canvas").prop('checked')) {
				object.opacity = 0;
				object.selectable = false;
			} else {
				object.opacity = 1;
				object.selectable = true;
			}
			$('.productGroup').find("#" + object.skutxt).hide();
		}
	}

	fabcanvas.discardActiveObject().renderAll();
}

function checkIFProductExists(productids, sku) {
	return productids.indexOf(String(sku)) === -1;
}

export function udpateGroupLabels() {

	if (!fabcanvas) return false;

	const objects = fabcanvas.getObjects().filter(function (o) {
		return o.skutxt !== '';
	});

	for (let i = 0; i < objects.length; i++) {
		const object = objects[i];
		if (object.skutxt) {
			const options = {
				left: object.left,
				top: object.top,
				scaleX: object.scaleX,
				scaleY: object.scaleY
			}
			addGroupedImage(object.pimage, options, object.pname, object.skutxt, object.productcolorcode, object.productwprice, object.productrprice, object.opacity);
			fabcanvas.remove(object);
		}
	}
	fabcanvas.discardActiveObject().renderAll();
	saveCanvasState();
}

export function addText() {
	const text = new fabric.Textbox('Add Heading', {
		fontSize: 12,
		width: 50,
		fill: 'black',
		fontFamily: 'Roboto',
		fontWeight: 500
	});
	fabcanvas.add(text);
	text.center();
	fabcanvas.setActiveObject(text);
	fabcanvas.renderAll();
	saveCanvasState();
}
export function addRect() {
	const rect = new fabric.Rect({
		left: 100,
		top: 100,
		fill: 'transparent',
		stroke: 'black',
		strokeWidth: 1,
		strokeUniform: true,
		width: 200,
		height: 200,
	});
	fabcanvas.add(rect);
	rect.center();
	rect.sendToBack();
	fabcanvas.setActiveObject(rect);
	fabcanvas.renderAll();
	saveCanvasState();
}

function setCanvasWidthHeight(width, height) {
	const canvas = getCanvas();
	canvas.setDimensions({
		width: width,
		height: height
	});
	$(".resize-canvasarea").css({"height": height , "width": width});
	canvas.calcOffset();
	canvas.renderAll();
}

export function resetCanvasZoom(zPerc) {
	const canvas = getCanvas();
	zPerc = parseInt(zPerc);
	canvas_zoom_perc = zPerc;
	const w = $('.canvasArea').css('width').replace('px', '');
	const h = $('.canvasArea').css('height').replace('px', '');
	if (canvas_zoom_perc) {
		if (canvas_zoom_perc <= 100) {
			setCanvasWidthHeight(w, h);
			canvas.setZoom(canvas_zoom_perc / 100);
		} else {
			setCanvasWidthHeight(canvas.width * ((canvas_zoom_perc / 100) / canvas.getZoom()), canvas.height * ((canvas_zoom_perc / 100) / canvas.getZoom()));
			canvas.setZoom(canvas_zoom_perc / 100);
		}
		canvas.discardActiveObject();
		canvas.requestRenderAll();
		saveCanvasState();
	}
}


export function fittocanvas(options) {
	const canvas = getCanvas();
	let zPerc = 1;
	const w = $('.canvasArea').css('width').replace('px', '');
	const h = $('.canvasArea').css('height').replace('px', '');
	if (!canvas.getObjects().length) return false;
	const sel = new fabric.ActiveSelection(canvas.getObjects(), {
		canvas: canvas,
	});
	canvas.setActiveObject(sel);
	sel.left = sel.top = 5;
	sel.setCoords();
	canvas.requestRenderAll();
	const wPerc = (w / sel.width * sel.scaleX);
	const hPerc = (h / sel.height * sel.scaleY);
	zPerc = (wPerc < hPerc) ? wPerc * 100 : hPerc * 100;
	canvas_zoom_perc = zPerc;
	if (options === "FitToCanvas" || canvas_zoom_perc <= 100) {
		//setCanvasWidthHeight(w, h);
		setCanvasWidthHeight(canvas.width * ((canvas_zoom_perc / 100) / canvas.getZoom()), canvas.height * ((canvas_zoom_perc / 100) / canvas.getZoom()));
		canvas.setZoom(canvas_zoom_perc / 100);
	}
	setFittoCanvas(canvas_zoom_perc);
	canvas.discardActiveObject();
	canvas.requestRenderAll();
	saveCanvasState();
}


export function getFittoCanvas() {
	return FITCANVASVALUE;
}

export function setFittoCanvas(value) {
	FITCANVASVALUE = value;
}

export function handleZoomCanvas(value) {
	const canvas = getCanvas();
	const zValue = value;
	let zPerc = 1;
	zPerc = zValue;
	const w = $('.canvasArea').css('width').replace('px', '');
	const h = $('.canvasArea').css('height').replace('px', '');
	canvas_zoom_perc = zPerc;
	if (canvas_zoom_perc) {
		if (canvas_zoom_perc <= 100) {
			setCanvasWidthHeight(w, h);
			canvas.setZoom(canvas_zoom_perc / 100);
		} else {
			setCanvasWidthHeight(canvas.width * ((canvas_zoom_perc / 100) / canvas.getZoom()), canvas.height * ((canvas_zoom_perc / 100) / canvas.getZoom()));
			canvas.setZoom(canvas_zoom_perc / 100);
		}
		canvas.discardActiveObject();
		canvas.requestRenderAll();
		saveCanvasState();
	}
}


export function handleZoomChange(event) {
	const canvas = getCanvas();
	const zValue = event.target.value;
	let zPerc = 1;
	const w = $('.canvasArea').css('width').replace('px', '');
	const h = $('.canvasArea').css('height').replace('px', '');
	if (zValue === "FitToCanvas") {
		if (!canvas.getObjects().length) return false;
		const sel = new fabric.ActiveSelection(canvas.getObjects(), {
			canvas: canvas,
		});
		canvas.setActiveObject(sel);
		sel.left = sel.top = 5;
		sel.setCoords();
		canvas.requestRenderAll();
		const wPerc = (w / sel.width * sel.scaleX);
		const hPerc = (h / sel.height * sel.scaleY);
		zPerc = (wPerc < hPerc) ? wPerc * 100 : hPerc * 100;
		canvas.discardActiveObject();
		canvas.requestRenderAll();
	} else {
		zPerc = parseInt(zValue);
	}
	canvas_zoom_perc = zPerc;
	if (canvas_zoom_perc) {
		if (zValue === "FitToCanvas" || canvas_zoom_perc <= 100) {
			setCanvasWidthHeight(w, h);
			canvas.setZoom(canvas_zoom_perc / 100);
		} else {
			setCanvasWidthHeight(canvas.width * ((canvas_zoom_perc / 100) / canvas.getZoom()), canvas.height * ((canvas_zoom_perc / 100) / canvas.getZoom()));
			canvas.setZoom(canvas_zoom_perc / 100);
		}
		canvas.discardActiveObject();
		canvas.requestRenderAll();
		saveCanvasState();
	}
}

//Function to save canvas history for undo / redo.
export function saveCanvasState() {
	if (fabcanvas && fabcanvas.stateaction && fabcanvas.state) {
		const newstate = [];
		let index = fabcanvas.index;
		let state = fabcanvas.state;
		const statejson = JSON.stringify(fabcanvas.toJSON(CUSTOM_PROPS));
		if (state.length) {
			const laststatejson = state[state.length - 1];
			if (laststatejson === statejson)
				return false;
		}

		for (let i = 0; i <= index; i++) {
			newstate.push(state[i]);
		}
		state = newstate;
		state[++index] = statejson;

		if (state.length >= 80) state = state.splice(-5, 5);

		fabcanvas.state = state;
		fabcanvas.index = index;
	}
}

export function undo() {
	fabcanvas.stateaction = false;
	let index = fabcanvas.index;

	const state = fabcanvas.state;
	if (index > 0) {
		index -= 1;
		fabcanvas.clear().renderAll();
		fabcanvas.loadFromJSON(state[index], function () {
			fabcanvas.renderAll();
			fabcanvas.stateaction = true;
			fabcanvas.index = index;
			updateSelectionCanvasItems();
		});
	}
	else {
		fabcanvas.stateaction = true;
	}
}

export function redo() {
	let index = fabcanvas.index;
	const state = fabcanvas.state;

	fabcanvas.stateaction = false;
	if (index < state.length - 1) {
		fabcanvas.clear().renderAll();
		fabcanvas.loadFromJSON(state[index + 1], function () {
			fabcanvas.renderAll();
			fabcanvas.stateaction = true;
			index += 1;
			fabcanvas.index = index;
			updateSelectionCanvasItems();
		});
	}
	else {
		fabcanvas.stateaction = true;
	}
}

export function resetState() {
	fabcanvas.state = [];
	fabcanvas.index = 0;
	fabcanvas.stateaction = true;
}

export function getCanvasStateIndex() {
	return fabcanvas.index;
}

export function setActiveStyle(styleName, value, object) {

	const canvas = getCanvas();
	object = object || canvas.getActiveObject();

	if (!object) return;
	if (object.setSelectionStyles && object.isEditing) {
		const style = {};
		style[styleName] = value;
		object.setSelectionStyles(style);
		object.setCoords();
	} else {
		object.set(styleName, value);
	}
	object.setCoords();
	canvas.renderAll();
	saveCanvasState();
}

export function initCanvasEvents() {

	const canvas = getCanvas();
	canvas.on('mouse:down', function (opt) {
		updateToolbar();
		const evt = opt.e;
		if (evt.altKey === true) {
			this.isDragging = true;
			this.selection = false;
			this.lastPosX = evt.clientX;
			this.lastPosY = evt.clientY;
		}
	});
	canvas.on('mouse:move', function (opt) {
		if (this.isDragging) {
			const e = opt.e;
			const vpt = this.viewportTransform;
			vpt[4] += e.clientX - this.lastPosX;
			vpt[5] += e.clientY - this.lastPosY;
			this.requestRenderAll();
			this.lastPosX = e.clientX;
			this.lastPosY = e.clientY;
		}
	});
	canvas.on('mouse:up', function () {
		// on mouse up we want to recalculate new interaction
		// for all objects, so we call setViewportTransform
		this.setViewportTransform(this.viewportTransform);
		this.isDragging = false;
		this.selection = true;
	});

	canvas.on({
		'object:modified': () => {
			saveCanvasState();
		},
		'text:editing:exited': () => {
			saveCanvasState();
		},
	});
}

export function updateToolbar() {
	const canvas = getCanvas();
	const selectedObject = canvas.getActiveObject();
	if (selectedObject && selectedObject.type == "textbox") {
		$(".fontSizeBtn").css("display", "flex");
		if (selectedObject.fontSize) {
			$('#textSize').val(selectedObject.fontSize);
		}
	} else {
		$(".fontSizeBtn").css("display", "none");
	}
}

export function addVLine() {
	const vline = new fabric.Line([50, 50, 50, 200], {
		stroke: 'black',
		strokeWidth: 2,
		padding: 20
	});
	fabcanvas.add(vline);
	vline.center();
	vline.sendToBack();
	fabcanvas.setActiveObject(vline);
	fabcanvas.renderAll();
	saveCanvasState();
}

export function addHLine() {
	const hline = new fabric.Line([100, 100, 300, 100], {
		stroke: 'black',
		strokeWidth: 2,
		padding: 20
	});
	fabcanvas.add(hline);
	hline.center();
	hline.sendToBack();
	fabcanvas.setActiveObject(hline);
	fabcanvas.renderAll();
	saveCanvasState();
}

export function addLineArrow() {
	const canvas = getCanvas();
	const triangle = new fabric.Triangle({
		width: 10,
		height: 15,
		fill: 'black',
		left: 235,
		top: 65,
		angle: 90
	});

	const line = new fabric.Line([50, 100, 200, 100], {
		left: 75,
		top: 70,
		stroke: 'black'
	});

	const objs = [line, triangle];

	const linearrowObj = new fabric.Group(objs);
	canvas.add(linearrowObj);

	linearrowObj.padding = 20;

	linearrowObj.center();
	linearrowObj.sendToBack();
	fabcanvas.setActiveObject(linearrowObj);
	fabcanvas.renderAll();
	saveCanvasState();
}

export function isValidDate(stringDate) {
	// Convert the string date to a Date object
	const date = new Date(stringDate);
	const todayDate = new Date();

	const dateMonth = date.getMonth();
	const todayMonth = todayDate.getMonth();

	const dateYear = date.getFullYear();
	const todayYear = todayDate.getFullYear();

	// Compare the months
	if ((dateMonth < todayMonth) && (dateYear <= todayYear)) {
		return false;
	} else {
		return true;
	}
}

export function calculateXYWidthHeight(containerWidth, containerHeight, imageWidth, imageHeight) {
	let newWidth = containerWidth;
	let newHeight = containerHeight;
	let x = 0;
	let y = 0;

	// Calculate aspect ratios
	const imageAspectRatio = imageWidth / imageHeight;
	const containerAspectRatio = containerWidth / containerHeight;

	// Image is wider than container
	if (imageAspectRatio > containerAspectRatio) {
		newWidth = containerWidth;
		newHeight = containerWidth / imageAspectRatio;
		y = (containerHeight - newHeight) / 2;
	}
	// Image is taller than container
	else {
		newHeight = containerHeight;
		newWidth = containerHeight * imageAspectRatio;
		x = (containerWidth - newWidth) / 2;
	}

	return { x: x, y: y, width: newWidth, height: newHeight };
}

export function addPoweredByText(pdf, xMargin, pageWidth, pageHeight, logoBaseImg) {
	pdf.setFontSize(33 / 2);
	pdf.setTextColor(0, 0, 0);
	const powerdByText = "POWERED BY BRANDSCOPE";
	const textWidth = pdf.getTextWidth(powerdByText);
	const dim = pdf.getTextDimensions(powerdByText);

	pdf.addImage(logoBaseImg, "JPEG", pageWidth - (textWidth + xMargin + 20), pageHeight - (xMargin + 15), dim.h, dim.h);

	pdf.text(powerdByText, pageWidth - (textWidth + xMargin), pageHeight - (xMargin));
}

export function addPageNumber(pdf, xMargin, pageWidth, pageHeight, pageNoText) {
	pdf.setFontSize(33 / 2);
	pdf.setTextColor(158, 158, 158);
	pdf.text(pageNoText, pageWidth - (pdf.getTextWidth(pageNoText) + xMargin), pageHeight - (xMargin));
}

export function addMonthTitle(pdf, pageWidth, xMargin, yMargin, title) {
	pdf.setFontSize(33 / 2);
	pdf.setTextColor(158, 158, 158);
	if (title) {
		const dim = pdf.getTextDimensions(title.toUpperCase());
		pdf.text(title.toUpperCase(), pageWidth - (pdf.getTextWidth(title.toUpperCase()) + xMargin), yMargin + dim.h);
	}
}